var map = {
	"./Oval.png": "7aca",
	"./avid-reader.svg": "8f27",
	"./award.png": "1a72",
	"./award.svg": "f5ce",
	"./bronze.svg": "6bd6",
	"./commabassador.svg": "995f",
	"./commaful-star.svg": "dc69",
	"./elite.svg": "3a61",
	"./frequent-reader.svg": "b692",
	"./gifted.svg": "6848",
	"./gold.svg": "d700",
	"./light-star.svg": "5860",
	"./power-reader.svg": "d8c4",
	"./verified.svg": "d644"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc4c";